import './index.less';



// WEBPACK FOOTER //
// ./components/locale-provider/style/index.tsx